import { styled, alpha } from '@mui/material/styles';
import LoadingButton from '@mui/lab/LoadingButton';


const QuoteButton = styled(LoadingButton)(({ theme }) => ({
    border: '1px solid',
    fontWeight: 800,
    // fontSize: '0.75rem',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    padding: '16px',
    width: '100%',
    '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        color: '#fff',
        border: '1px solid ' + theme.palette.secondary.grey,
        // border: 'none',
    },
    border: 'none'
}));

const AddToQuoteSecondary = ({children, aria, size, className, color, style, sx, onClick, loadingPosition, startIcon, variant}) => (
    <QuoteButton
        aria-label={aria}
        sx={sx}
        size={size}
        className={className}
        color={color}
        style={style}
        onClick={onClick} 
        loadingPosition={loadingPosition}
        startIcon={startIcon}
        variant={variant}
    >
        {children}
    </QuoteButton>
)


export default AddToQuoteSecondary